import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    // Dil değişimini localStorage'e kaydedebilirsiniz (opsiyonel)
    localStorage.setItem('preferred-language', lng);
  };

  return (
    <div className="flex space-x-1 border border-gray-700 rounded-lg overflow-hidden">
      <motion.button
        className={`px-3 py-1 text-sm font-medium transition-colors ${
          currentLanguage === 'tr' ? 'bg-cyan-700 text-white' : 'bg-transparent text-gray-400 hover:text-white'
        }`}
        onClick={() => changeLanguage('tr')}
        whileHover={{ backgroundColor: currentLanguage === 'tr' ? '#0e7490' : '#333333' }}
        whileTap={{ scale: 0.95 }}
      >
        TR
      </motion.button>
      <motion.button
        className={`px-3 py-1 text-sm font-medium transition-colors ${
          currentLanguage === 'en' ? 'bg-cyan-700 text-white' : 'bg-transparent text-gray-400 hover:text-white'
        }`}
        onClick={() => changeLanguage('en')}
        whileHover={{ backgroundColor: currentLanguage === 'en' ? '#0e7490' : '#333333' }}
        whileTap={{ scale: 0.95 }}
      >
        EN
      </motion.button>
    </div>
  );
};

export default LanguageSwitcher;